import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import DataTable from '../components/DataTable'
import { KTSVG } from '../../_metronic/helpers'
import { formatDecimalQuantity } from '../helpers/GlobalHelper'

function ItemAverageRate() {
	const [historyModalShow, setHistoryModalShow] = useState(false)
	const [historyItemId, setHistoryItemId] = useState<number | null>(null)
	const [historyProjectId, setHistoryProjectId] = useState<number | null>(null)
	const [historyItemName, setHistoryItemName] = useState('')

	const openHistory = (row: any) => {
		setHistoryItemId(row.idItems)
		setHistoryProjectId(row.idProjects ?? null)
		setHistoryItemName(row.itemName || '')
		setHistoryModalShow(true)
	}

	const closeHistory = () => {
		setHistoryModalShow(false)
		setHistoryItemId(null)
		setHistoryProjectId(null)
		setHistoryItemName('')
	}

	const columns = [
		{ value: 'itemName', title: 'Item Name', style: { textAlign: 'left' } },
		{ value: 'itemCode', title: 'Item Code', style: { textAlign: 'left' } },
		{ value: 'categoryName', title: 'Category', style: { textAlign: 'left' } },
		{ value: 'unitName', title: 'Unit', style: { textAlign: 'center' } },
		{ value: 'projectName', title: 'Project', style: { textAlign: 'left' } },
		{
			value: 'rate',
			title: 'Latest Rate',
			style: { textAlign: 'right' },
			hasHtmlComponent: true,
			htmlComponent: (row: any) => formatDecimalQuantity(row.rate, 4),
		},
		{ value: 'effectiveDate', title: 'Effective Date', style: { textAlign: 'center' } },
		{ value: 'refType', title: 'Source', style: { textAlign: 'center' } },
		{
			value: 'action',
			title: 'Action',
			style: { textAlign: 'center', whiteSpace: 'nowrap' },
			hasActionsComponent: true,
			actionsComponent: (row: any) => (
				<button type="button" className="btn btn-light-primary btn-sm p-2" onClick={() => openHistory(row)}>
					<KTSVG path="/media/svg/icons/Text/Bullet-list.svg" className="svg-icon-5 svg-icon" />
					&nbsp;View History
				</button>
			),
		},
	]

	const filters = {
		itemName: { filterType: 'like', filterValue: '' },
		itemCode: { filterType: 'like', filterValue: '' },
		categoryName: { filterType: 'like', filterValue: '' },
		unitName: { filterType: 'like', filterValue: '' },
		projectName: { filterType: 'like', filterValue: '' },
		rate: { filterType: 'like', filterValue: '' },
		effectiveDate: { filterType: 'like', filterValue: '' },
		refType: { filterType: 'like', filterValue: '' },
	}

	const historyColumns = [
		{ value: 'effectiveDate', title: 'Effective Date', style: { textAlign: 'center' } },
		{
			value: 'rate',
			title: 'Rate',
			style: { textAlign: 'right' },
			hasHtmlComponent: true,
			htmlComponent: (row: any) => formatDecimalQuantity(row.rate, 4),
		},
		{ value: 'projectName', title: 'Project', style: { textAlign: 'left' } },
		{ value: 'refType', title: 'Source', style: { textAlign: 'center' } },
		{ value: 'refId', title: 'Ref ID', style: { textAlign: 'center' } },
		{ value: 'createdBy', title: 'Recorded By', style: { textAlign: 'left' } },
		{ value: 'createdAt', title: 'Recorded At', style: { textAlign: 'left' } },
	]

	const historyFilters = {
		effectiveDate: { filterType: 'like', filterValue: '' },
		rate: { filterType: 'like', filterValue: '' },
		projectName: { filterType: 'like', filterValue: '' },
		refType: { filterType: 'like', filterValue: '' },
		refId: { filterType: 'like', filterValue: '' },
		createdBy: { filterType: 'like', filterValue: '' },
		createdAt: { filterType: 'like', filterValue: '' },
	}

	const url = process.env.REACT_APP_API_URL + 'item-average-rates/dt'
	const historyUrl = process.env.REACT_APP_API_URL + 'item-average-rates/history/dt'

	return (
		<div className="card card-custom">
			<div className="card-header">
				<div className="card-title">
					<KTSVG path="/media/svg/icons/Text/Bullet-list.svg" className="svg-icon-1 svg-icon-primary" />
					<span className="text fw-bolder" style={{ marginLeft: '10px' }}>
						Item Average Rate
					</span>
				</div>
			</div>

			<div className="card-body">
				<DataTable url={url} columns={columns} filters={filters} defaultSortedColumn="itemName" defaultSortOrder="ASC" />
			</div>

			<Modal show={historyModalShow} onHide={closeHistory} size="xl" centered scrollable>
				<Modal.Header closeButton>
					<Modal.Title>Average Rate History{historyItemName ? ` - ${historyItemName}` : ''}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{historyItemId ? (
						<DataTable
							url={historyUrl}
							columns={historyColumns}
							filters={historyFilters}
							additionalPostData={{
								idItems: historyItemId,
								idProjects: historyProjectId,
							}}
							defaultSortedColumn="effectiveDate"
							defaultSortOrder="DESC"
						/>
					) : (
						<p>No item selected.</p>
					)}
				</Modal.Body>
			</Modal>
		</div>
	)
}

export default ItemAverageRate
